import { businessPath } from 'utils/businessRoutes'
import React from 'react'
import { NavLink, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Box, Drawer, List, ListItem, ListItemAvatar, ListItemText } from '@mui/material'
import {
  LocalOfferOutlined as OfferIcon,
  InfoOutlined as InfoIcon,
  Payment as PaymentIcon,
  Add as AddIcon,
  ReceiptOutlined as TransactionIcon,
  AssessmentOutlined as DashboardIcon,
} from '@mui/icons-material'
import { CompanySelector, MenuItem } from 'components'
import { showBusinessForm } from 'modules/UI/actions'
import LogoSrc from 'components/Logo/Logo.png'

const Sidebar = ({ businesses }) => {
  const dispatch = useDispatch()
  const userReadOnly = useSelector(state => state.user.details?.lifecycleStatus === 'SUSPENDED')

  const { businessId, organizationId } = useParams();
  return (
    <Drawer
      variant="permanent"
      anchor="left"
      sx={{
        boxShadow: 2,
        '& .MuiDrawer-paper': {
          width: 300,
          boxSizing: 'border-box',
          '& .MuiListItemText-root': { minWidth: 0 },
          '& .MuiListItemText-primary': { overflowWrap: 'anywhere' },
        },
      }}
    >
      <Box pt={6} pb={4} width={300} display="flex" justifyContent="center">
        <NavLink to="/">
          <img src={LogoSrc} alt="" height={62} />
        </NavLink>
      </Box>
      {
        businesses &&
        <>
          <CompanySelector />
          <List sx={{ '& .MuiTypography-root': { color: 'black !important' } }} >
            <MenuItem disabled={!businesses} icon={<DashboardIcon sx={{ color: 'black' }}/>} text="Dashboard" link={businessPath(businessId, organizationId, 'dashboard') } />
            <MenuItem disabled={!businesses} icon={<OfferIcon sx={{ color: 'black' }}/>} text="Offers" link={businessPath(businessId, organizationId, 'offers')} />
            <MenuItem disabled={!businesses} icon={<TransactionIcon sx={{ color: 'black' }}/>} text="Transactions" link={businessPath(businessId, organizationId, 'transactions')} />
            <MenuItem disabled={!businesses} icon={<PaymentIcon sx={{ color: 'black' }}/>} text="Payments" link={businessPath(businessId, organizationId, 'payments')} />
            <MenuItem disabled={!businesses} icon={<InfoIcon sx={{ color: 'black' }}/>} text="Business profile" link={businessPath(businessId, organizationId, 'profile')} />
          </List>
        </>
      }
      <Box py={3}>
        <List>
          <ListItem button disabled={userReadOnly} onClick={() => {
            dispatch(showBusinessForm())
          }} style={{ background: '#eee' }}>
            <ListItemAvatar>
              <AddIcon />
            </ListItemAvatar>
            <ListItemText>
              Create new business
            </ListItemText>
          </ListItem>
        </List>
      </Box>

    </Drawer>
  )
}

export default Sidebar
